export const colors = {
  lightBlue: '#3CAFC8',
  lightGreen: '#3CC8C0',
  darkRed: '#C83C66',
  green: '#7AD81B',
  yellow: '#FFE249',
  red: '#E64F49',
  orange: '#E88B1E',
  grey: '#808080',
  a5grey: '#A5A5A5',
  black: '#222222',
};
